import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import caseNestService from "../../services/caseNestService";

const useSnippets = (caseTypeId, accountId) =>
  useQuery([queryKeys.snippets, caseTypeId, accountId], () => caseNestService.fetchSnippets(caseTypeId, accountId), {
    enabled: !!caseTypeId || caseTypeId === 0,
  });

export default useSnippets;
